<!-- =========================================================================================
  File Name: VerticalNavMenu.vue
  Description: Vertical NavMenu Component
  Component Name: VerticalNavMenu
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div class="parentx">
<!--    固定往左边缩小的效果 参照crm-web-->
<!--    隐藏的bug pc端转移动端然后点击赠金记录,再转为pc端 再点击输入框(经查看元素是点击蒙版层), 左边的菜单栏就不见了 todo-->
    <vs-sidebar
      class="v-nav-menu items-no-padding"
      v-model="isVerticalNavMenuActive"
      ref="verticalNavMenu"
      default-index="-1"
      :click-not-close="clickNotClose"
      :reduce-not-rebound="reduceNotRebound"
      :parent="parent"
      :hiddenBackground="clickNotClose"
      :reduce="reduce"
      v-hammer:swipe.left="onSwipeLeft">

      <div @mouseenter="mouseEnter" @mouseleave="mouseLeave">

        <!-- Header -->
        <div
          class="header-sidebar flex items-end justify-between"
          :class="{hasBg: userInfo.custType == 1}"
          slot="header"
        >

          <!-- Logo -->
          <router-link exact tag="div" class="vx-logo flex items-center" to="">
            <img
              v-if="isMouseEnter || !reduce"
              class="long-logo"
              src="../../../assets/images/logo/logo.png"
              alt=""
            >
            <logo
              v-else
              class="w-10 mr-4 fill-current text-primary"
            />
<!--            <span class="vx-logo-text text-primary" v-show="isMouseEnter || !reduce" v-if="title">{{ title }}</span>-->
          </router-link>
          <!-- /Logo -->

<!--           Menu Buttons-->
          <div>
<!--             Close Button-->
            <template v-if="showCloseButton">
              <feather-icon icon="XIcon" class="m-0 cursor-pointer" @click.stop="$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)" />
            </template>

<!--             Toggle Buttons-->
            <template v-else-if="!showCloseButton && !verticalNavMenuItemsMin">
              <feather-icon
                id="btnVNavMenuMinToggler"
                class="mr-0 cursor-pointer"
                :icon="reduce ? 'CircleIcon' : 'DiscIcon'"
                svg-classes="stroke-current text-primary"
                @click="toggleReduce(!reduce)" />
            </template>
          </div>
<!--           /Menu Toggle Buttons -->
        </div>
        <ib-toggle
          v-if="userInfo.custType == 1"
          :is-reduce="reduce"
          :is-mouse-enter="isMouseEnter"
        ></ib-toggle>
        <!-- /Header -->
        <div
          v-if="userInfo.custType == 1"
          class="shadow-self"></div>
        <!-- Header Shadow -->
        <div class="shadow-bottom" v-show="showShadowBottom" />

        <!-- Menu Items -->
        <VuePerfectScrollbar ref="verticalNavMenuPs" class="scroll-area-v-nav-menu pt-2" :settings="settings" @ps-scroll-y="psSectionScroll" :key="$vs.rtl">
<!--需要做账号未激活,除了首页其他的菜单都不能访问-->
          <template v-for="(item, index) in menusComputed">
              <!-- Nav-Item -->
              <v-nav-menu-item
                :key="`item-${index}`"
                v-if="!item.children"
                :to="getTo(item)"
                :icon="item.icon"
                :z-index="index"
                :menu-item="item"
              >
                  <span v-show="!verticalNavMenuItemsMin" class="truncate">{{ getTitle(item) }}</span>
              </v-nav-menu-item>

              <!-- Nav-Group -->
            <v-nav-menu-group
              v-if="item.children && item.children.length"
              :key="`group-${index}`"
              :openHover="openGroupHover"
              :group="item"
              :groupIndex="index"
              :open="getIsGroupActive(item)"
              :to="getTo(item)"

            />
              <!-- /Nav-Group -->
          </template>
        </VuePerfectScrollbar>
        <!-- /Menu Items -->
      </div>
    </vs-sidebar>

    <!-- Swipe Gesture -->
    <div
      v-if="!isVerticalNavMenuActive"
      class="v-nav-menu-swipe-area"
      v-hammer:swipe.right="onSwipeAreaSwipeRight" />
    <!-- /Swipe Gesture -->
  </div>
</template>

<script>
import ibToggle from "@/layouts/components/navbar/components/ibToggle";
  import menus from './menus'
  import { MenuIsExpand } from '@/utils/common'
  import { mapGetters } from 'vuex'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VNavMenuGroup from './VerticalNavMenuGroup.vue'
import VNavMenuItem from './VerticalNavMenuItem.vue'

import Logo from "../Logo.vue"

export default {
  name: 'v-nav-menu',
  components: {
    VNavMenuGroup,
    VNavMenuItem,
    VuePerfectScrollbar,
    Logo,
    ibToggle,
  },
  props: {
    logo:             { type: String },
    openGroupHover:   { type: Boolean, default: false },
    parent:           { type: String },
    reduceNotRebound: { type: Boolean, default: true },
    title:            { type: String },
  },
  data: () => ({
    clickNotClose       : false, // disable close navMenu on outside click
    isMouseEnter        : false,
    reduce              : false, // determines if navMenu is reduce - component property
    showCloseButton     : false, // show close button in smaller devices
    settings            : {      // perfectScrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed        : 1,
      swipeEasing       : true
    },
    showShadowBottom    : false,
    menus: menus,
  }),
  computed: {
    ...mapGetters(['language','userInfo','integralFeatureFlag','agentRole']),
    isNormal(){

      let flag = true;
      if(this.userInfo.custStatus == 1 || this.userInfo.custStatus == 10){
        flag = false;
      }else {
        if(this.userInfo.auditStatus !==4){
          flag = false;
        }else {
          flag = true;
        }
      }
      return flag;
    },
    agentRoleIsIb(){
      return this.userInfo.custType == 1 && this.agentRole == 'IB';
    },
    isCustomerSystem(){
      return this.userInfo.custType == 3 || (this.userInfo.custType == 1 && this.agentRole == 'CUSTOMER');
    },
    menusComputed(){
      let menuLast = [];
      let deepCopyMenus = JSON.parse(JSON.stringify(this.menus));
      if(this.isCustomerSystem){
        // 直客系统
        let ibMenu = ['myCustomer','agentFundsList','agentTradeHistory','commissionRecord','commissionOutRecord','symbolStatistics','performanceStatistics',]
        menuLast = deepCopyMenus.filter((item,index) => {
          return !ibMenu.includes(item.componentName);
        });
      }else {
        //代理 代理角色默认显示的是代理系统
        let customerMenu = ['fundsManagement','integralModule','bonusManagement','traderReport','bonusList','copyMaster'];  // 这些是客户系统的菜单
        menuLast = deepCopyMenus.filter((item,index) => {
          return !customerMenu.includes(item.componentName);
        });

      }
      if (!this.isNormal) {
        // 禁用所有操作菜单
        this.handlerMenu(menuLast);
      }
      // 英文版没有积分商城
      if(this.language == 'en_US' || !this.integralFeatureFlag){
        menuLast = menuLast.filter((item,index) => {
          return item.componentName != 'integralModule';
        })
      }

      return menuLast;
    },
    isVerticalNavMenuActive: {
      get()    { return this.$store.getters.isVerticalNavMenuActive },
      set(val) { this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', val) }
    },
    layoutType() { return this.$store.getters.mainLayoutType },
    reduceButton: {
      get()    { return this.$store.getters.reduceButton },
      set(val) { this.$store.commit('TOGGLE_REDUCE_BUTTON', val) }
    },
    isVerticalNavMenuReduced()   { return Boolean(this.reduce && this.reduceButton) },
    verticalNavMenuItemsMin() { return this.$store.getters.verticalNavMenuItemsMin },
    windowWidth()     { return this.$store.getters.windowWidth }
  },
  watch: {
    '$route'() {
      if (this.isVerticalNavMenuActive && this.showCloseButton) this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
    },
    reduce(val) {
      const verticalNavMenuWidth = val ? "reduced" : this.$store.getters.windowWidth < 1200 ? "no-nav-menu" : "default"
      this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)

      setTimeout(function() {
        window.dispatchEvent(new Event('resize'))
      }, 100)
    },
    layoutType()   { this.setVerticalNavMenuWidth() },
    reduceButton() { this.setVerticalNavMenuWidth() },
    windowWidth()  { this.setVerticalNavMenuWidth() }
  },
  methods: {

    handlerMenu(menuArray){
      for (let i = 0; i < menuArray.length; i++) {
        if(menuArray[i].componentName === 'securitySettings' || menuArray[i].componentName === 'dashboard'){
          menuArray[i].disabled = false;
        }else {
          menuArray[i].disabled = true;
        }
        if(menuArray[i].children && menuArray[i].children.length){
          this.handlerMenu(menuArray[i].children);
        }
      }
    },
    getIsGroupActive(item) {
      return MenuIsExpand(item, this);
    },
    getTitle(item){
      return item.name;
    },
    getTo(item){
      return {name: item.componentName};
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setVerticalNavMenuWidth()
    },
    onSwipeLeft() {
      if (this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = false
    },
    onSwipeAreaSwipeRight() {
      if (!this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = true
    },
    psSectionScroll() {
      this.showShadowBottom = this.$refs.verticalNavMenuPs.$el.scrollTop > 0 ? true : false
    },
    mouseEnter() {
      if (this.reduce) this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)
      this.isMouseEnter = true
    },
    mouseLeave() {
      if (this.reduce) this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', true)
      // if (this.reduce) this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)// 调试样式
      this.isMouseEnter = false;
    },
    setVerticalNavMenuWidth() {
      if(this.windowWidth > 1200) {
        if(this.layoutType === 'vertical') {

          // Set reduce
          this.reduce = this.reduceButton ? true : false;

          // Open NavMenu
          this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

          // Set Menu Items Only Icon Mode
          const verticalNavMenuItemsMin = (this.reduceButton && !this.isMouseEnter) ? true : false
          this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

          // Menu Action buttons
          this.clickNotClose   = true
          this.showCloseButton = false

          const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? "reduced" : "default"
          this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)

          return
        }
      }

      // Close NavMenu
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      // Reduce button
      if (this.reduceButton) this.reduce = false

      // Menu Action buttons
      this.showCloseButton = true
      this.clickNotClose   = false

      // Update NavMenu Width
      this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      // Remove Only Icon in Menu
      this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)



      if(this.layoutType === 'vertical' || (this.layoutType === 'horizontal' && this.windowWidth < 1200))
      if (this.windowWidth < 1200) {

        // Close NavMenu
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

        // Reduce button
        if (this.reduceButton) this.reduce = false

        // Menu Action buttons
        this.showCloseButton = true
        this.clickNotClose   = false

        // Update NavMenu Width
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

        // Remove Only Icon in Menu
        this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)

      } else {

        // Set reduce
        this.reduce = this.reduceButton ? true : false

        // Open NavMenu
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

        // Set Menu Items Only Icon Mode
        const verticalNavMenuItemsMin = (this.reduceButton && !this.isMouseEnter) ? true : false
        this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

        // Menu Action buttons
        this.clickNotClose   = true
        this.showCloseButton = false

        const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? "reduced" : "default"
        this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)
      }
    },
    toggleReduce(val) {
      this.reduceButton = val
      this.setVerticalNavMenuWidth()
    },
  },
  mounted() {
    this.setVerticalNavMenuWidth();

  },
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/verticalNavMenu.scss";
// 改造的

.v-nav-menu .vs-sidebar.vs-sidebar-reduce .vs-sidebar-group .group-header i {
  display: block;
}
.header-sidebar {
  &.hasBg {
    background-color: #F8F8F8!important;
    padding-bottom: 40px;
  }
}
 .v-nav-menu {
    .vs-sidebar {
      &.vs-sidebar-reduce {
        .vs-sidebar--item a {
          padding-left: 5px;
        }
        .vs-sidebar--item i {
          padding-top: 0;
          padding-bottom: 0;
        }
      }
    }
   .vs-sidebar-group .vs-sidebar-group-items .vs-sidebar--item a {
     //padding-left: 15px;
   }
}
 .long-logo {
   height: 30px;
 }
 .shadow-self {
   //height: 20px;
   //margin-bottom: 10px;
 }
</style>
